// Structured, bilingual content data for I.E.P.E.M. S.r.l.

export const CONTACT = {
  companyName: "I.E.P.E.M. S.r.l.",
  ceo: "Baiocco Davide",
  techDirector: "Roscini Mario",
  address: "Strada delle Selvette, 2/R — Loc. Pieve Pagliaccia, 06134 Perugia (PG)",
  phone: "+39 075 5913283",
  phoneHref: "tel:+390755913283",
  email: "iepem@iepem.it",
  pec: "iepem@legalmail.it",
  vat: "01302570542",
  rea: "134466 (Perugia)",
};

export const STATS = [
  { key: "founded", value: "1982", labelKey: "stats.founded" },
  { key: "people", value: "40+", labelKey: "stats.people" },
  { key: "iso", value: "ISO 9001", labelKey: "stats.iso" },
  { key: "soa", value: "SOA", labelKey: "stats.soa" },
];

export const HERO_STATS = [
  { value: "24h", labelKey: "stats.intervention" },
  { value: "100%", labelKey: "stats.turnkey" },
  { value: "40+", labelKey: "stats.founded" },
];

export const SERVICES = [
  {
    id: "carburanti",
    num: "01",
    it: {
      title: "Stazioni di servizio carburanti",
      text: "Costruzione e ristrutturazione di punti vendita e aree di servizio, sia per la parte OIL (piazzale) che NON OIL (fabbricati).",
    },
    en: {
      title: "Fuel service stations",
      text: "Construction and renovation of retail points and service areas, both the OIL (forecourt) and NON-OIL (buildings) sides.",
    },
    image: "/projects/tamoil-notturna.jpg",
  },
  {
    id: "ristorazione",
    num: "02",
    it: {
      title: "Ristorazione e aree ristoro",
      text: "Costruzione e ristrutturazione per i principali brand della ristorazione italiana su reti stradali e autostradali.",
    },
    en: {
      title: "Catering & rest areas",
      text: "Construction and renovation for Italy's leading catering brands on road and motorway networks.",
    },
    image: "/projects/roadhouse-facciata.jpg",
  },
  {
    id: "edilizia",
    num: "03",
    it: {
      title: "Edilizia civile e industriale",
      text: "Edifici di civile abitazione, locali commerciali e industriali. Interventi con Bonus Edilizi, ricostruzione Sisma 2016 e PNRR.",
    },
    en: {
      title: "Civil & industrial building",
      text: "Residential buildings, commercial and industrial premises. Works under building bonuses, 2016 earthquake reconstruction and PNRR.",
    },
    image: "/projects/nursia-esterno.jpg",
  },
  {
    id: "infrastrutture",
    num: "04",
    it: {
      title: "Infrastrutture e lottizzazioni",
      text: "Infrastrutture stradali e opere di urbanizzazione per aree da lottizzare, in ambito sia privato che pubblico.",
    },
    en: {
      title: "Infrastructure & development",
      text: "Road infrastructure and urbanisation works for areas to be developed, both private and public.",
    },
    image: "/projects/autogrill-laterale.jpg",
  },
];

export const PROJECT_CATEGORIES = [
  { id: "petrolifero", it: "Settore petrolifero", en: "Fuel sector" },
  { id: "ristorazione", it: "Ristorazione", en: "Catering" },
  { id: "civile", it: "Civile e post-sisma", en: "Civil & post-quake" },
];

export const PROJECTS = [
  {
    id: "tamoil-notturna",
    category: "petrolifero",
    image: "/projects/tamoil-notturna.jpg",
    client: "Tamoil Italia S.p.A.",
    location: "Badia Nuova Ovest (BO)",
    it: "Impianto carburanti — vista notturna",
    en: "Fuel station — night view",
  },
  {
    id: "tamoil-diurna",
    category: "petrolifero",
    image: "/projects/tamoil-diurna.jpg",
    client: "Tamoil Italia S.p.A.",
    location: "Badia Nuova Ovest (BO)",
    it: "Impianto carburanti — vista diurna",
    en: "Fuel station — day view",
  },
  {
    id: "autogrill-frontale",
    category: "petrolifero",
    image: "/projects/autogrill-frontale.jpg",
    client: "Autogrill S.p.A.",
    location: "ADS Chianti — Bagno a Ripoli (FI)",
    it: "Area di servizio — vista frontale",
    en: "Service area — front view",
  },
  {
    id: "autogrill-laterale",
    category: "petrolifero",
    image: "/projects/autogrill-laterale.jpg",
    client: "Autogrill S.p.A.",
    location: "ADS Chianti — Bagno a Ripoli (FI)",
    it: "Area di servizio — vista laterale",
    en: "Service area — side view",
  },
  {
    id: "roadhouse-facciata",
    category: "ristorazione",
    image: "/projects/roadhouse-facciata.jpg",
    client: "Roadhouse Grill",
    location: "Lido di Camaiore (LU)",
    it: "Esterno — nuova facciata",
    en: "Exterior — new façade",
  },
  {
    id: "roadhouse-ingresso",
    category: "ristorazione",
    image: "/projects/roadhouse-ingresso.jpg",
    client: "Roadhouse Grill",
    location: "Lido di Camaiore (LU)",
    it: "Esterno — ingresso principale",
    en: "Exterior — main entrance",
  },
  {
    id: "roadhouse-sala",
    category: "ristorazione",
    image: "/projects/roadhouse-sala.jpg",
    client: "Roadhouse Grill",
    location: "Lido di Camaiore (LU)",
    it: "Interno — sala ristorante",
    en: "Interior — dining hall",
  },
  {
    id: "roadhouse-bar",
    category: "ristorazione",
    image: "/projects/roadhouse-bar.jpg",
    client: "Roadhouse Grill",
    location: "Lido di Camaiore (LU)",
    it: "Interno — area bar",
    en: "Interior — bar area",
  },
  {
    id: "chef-esterno",
    category: "ristorazione",
    image: "/projects/chef-esterno.jpg",
    client: "Chef Express",
    location: "Lucignano Est (AR)",
    it: "Esterno — struttura completata",
    en: "Exterior — completed structure",
  },
  {
    id: "chef-completati",
    category: "ristorazione",
    image: "/projects/chef-completati.jpg",
    client: "Chef Express",
    location: "Lucignano Est (AR)",
    it: "Interno — lavori completati",
    en: "Interior — completed works",
  },
  {
    id: "chef-spazi",
    category: "ristorazione",
    image: "/projects/chef-spazi.jpg",
    client: "Chef Express",
    location: "Lucignano Est (AR)",
    it: "Interno — spazi completati",
    en: "Interior — completed spaces",
  },
  {
    id: "montalto-prima",
    category: "civile",
    image: "/projects/montalto-prima.jpg",
    client: "Comune di Montalto delle Marche",
    location: "Sisma 2016",
    it: "Edificio prima dei lavori",
    en: "Building before works",
  },
  {
    id: "montalto-ricostruzione",
    category: "civile",
    image: "/projects/montalto-ricostruzione.jpg",
    client: "Comune di Montalto delle Marche",
    location: "Sisma 2016",
    it: "Ricostruzione in corso",
    en: "Reconstruction in progress",
  },
  {
    id: "nursia-esterno",
    category: "civile",
    image: "/projects/nursia-esterno.jpg",
    client: "Cioccolateria Vetusta Nursia",
    location: "Norcia (PG) · Sisma 2016",
    it: "Edificio storico — esterno",
    en: "Historic building — exterior",
  },
];

export const SOA_ROWS = [
  {
    cat: "OG1",
    it: "Edifici civili e industriali",
    en: "Civil and industrial buildings",
    cls: "IV-bis",
  },
  {
    cat: "OG3",
    it: "Strade, autostrade, ponti, viadotti, ferrovie",
    en: "Roads, motorways, bridges, viaducts, railways",
    cls: "III-bis",
  },
  {
    cat: "OG6",
    it: "Acquedotti, gasdotti, oleodotti, opere di irrigazione",
    en: "Aqueducts, gas & oil pipelines, irrigation works",
    cls: "I",
  },
];

export const QUALIFICATIONS = [
  {
    it: "Anagrafe Antimafia degli Esecutori",
    en: "Anti-mafia Register of Contractors",
    org: "Ministero dell'Interno",
  },
  {
    it: "Qualificazione ricostruzione post-sisma",
    en: "Post-earthquake reconstruction qualification",
    org: "Regione Umbria — dal 09/11/2001",
  },
  {
    it: "Elenco esecutori edilizia scolastica",
    en: "School-building contractors list",
    org: "INVITALIA",
  },
  {
    it: "Elenco operatori lavori pubblici",
    en: "Public works operators list",
    org: "SUAM Regione Marche",
  },
  {
    it: "Elenco Regionale Imprese",
    en: "Regional Register of Companies",
    org: "Regione Umbria (art. 26 L.R. 3/2010)",
  },
  {
    it: "Cassa Edile — congruità triennale",
    en: "Cassa Edile — three-year compliance",
    org: "Certificazione dei versamenti",
  },
  {
    it: "Rating di Legalità — ★★",
    en: "Legality Rating — ★★",
    org: "Autorità Garante della Concorrenza e del Mercato",
    note_it: "Punteggio intermedio che certifica il rispetto di elevati standard etici e di legalità aziendale, superando i requisiti minimi di base.",
    note_en: "Intermediate score certifying compliance with high ethical and corporate-legality standards, going beyond the basic minimum requirements.",
    highlight: true,
  },
];

export const CLIENTS = [
  "Gruppo A.P.I.",
  "SHELL Italia",
  "Tamoil",
  "Q8 — Kuwait Petroleum",
  "Autogrill",
  "McDonald's",
  "Chef Express",
  "Roadhouse Grill",
  "Gruppo Cremonini",
  "Hitrac Engineering",
  "Ater Umbria",
  "Regione Umbria",
];

export const VALUES = [
  {
    num: "01",
    it: { title: "Onestà", text: "Trasparenza e coerenza in ogni rapporto, con clienti, partner e collaboratori." },
    en: { title: "Honesty", text: "Transparency and consistency in every relationship — with clients, partners and collaborators." },
  },
  {
    num: "02",
    it: { title: "Rispetto", text: "Per le persone, per i tempi, per l'ambiente e per il territorio in cui operiamo." },
    en: { title: "Respect", text: "For people, for deadlines, for the environment and the territory where we operate." },
  },
  {
    num: "03",
    it: { title: "Contributo", text: "Portare valore concreto a individui, imprese e comunità in ogni sfida." },
    en: { title: "Contribution", text: "Bringing concrete value to individuals, companies and communities in every challenge." },
  },
  {
    num: "04",
    it: { title: "Abbondanza", text: "Crescere insieme, condividendo risultati, competenze e opportunità." },
    en: { title: "Abundance", text: "Growing together, sharing results, skills and opportunities." },
  },
  {
    num: "05",
    it: { title: "Amore", text: "La passione per il costruire bene, la cura del dettaglio in ogni cantiere." },
    en: { title: "Love", text: "The passion for building well, and care for detail on every site." },
  },
];

export const POLICIES = [
  {
    num: "01",
    it: { title: "Formazione e cultura della sicurezza", text: "Investire sulla formazione del personale significa progettare cambiamenti e adeguamenti alle leggi di mercato in modo snello e senza traumi. IEPEM adotta un sistema di gestione della qualità ISO 9001:2015, certificato da Bureau Veritas S.p.A." },
    en: { title: "Training & safety culture", text: "Investing in staff training means designing changes and adapting to market regulations smoothly and without disruption. IEPEM adopts an ISO 9001:2015 quality management system, certified by Bureau Veritas S.p.A." },
  },
  {
    num: "02",
    it: { title: "Rispetto e salvaguardia dell'ambiente", text: "In tutte le attività perseguiamo il miglioramento continuo nella tutela dell'ecologia e dell'ambiente, con strumenti tecnico-amministrativi, procedurali e operativi conformi al D.Lgs. 152/2006." },
    en: { title: "Respect & protection of the environment", text: "In all our activities we pursue continuous improvement in ecological and environmental protection, with technical, administrative, procedural and operational tools compliant with Italian Legislative Decree 152/2006." },
  },
  {
    num: "03",
    it: { title: "La qualità come fattore di successo", text: "La qualità è elemento di differenziazione sul mercato: la soddisfazione della clientela e l'efficienza dei processi di lavoro sono per noi fattori essenziali di competitività." },
    en: { title: "Quality as a success factor", text: "Quality sets us apart in the market: customer satisfaction and the efficiency of our work processes are essential competitive factors for us." },
  },
];

export const TEAM = [
  { it: { sector: "Tecnico", role: "Ingegneri" }, en: { sector: "Technical", role: "Engineers" }, n: 2 },
  { it: { sector: "Tecnico", role: "Geometri" }, en: { sector: "Technical", role: "Surveyors" }, n: 4 },
  { it: { sector: "Cantiere", role: "Capo Cantieri" }, en: { sector: "Site", role: "Site managers" }, n: 7 },
  { it: { sector: "Cantiere", role: "Idraulici specializzati" }, en: { sector: "Site", role: "Specialised plumbers" }, n: 2 },
  { it: { sector: "Amministrativo", role: "Laureati" }, en: { sector: "Administrative", role: "Graduates" }, n: 1 },
  { it: { sector: "Amministrativo", role: "Diplomati" }, en: { sector: "Administrative", role: "Diploma holders" }, n: 4 },
  { it: { sector: "Qualità e Sicurezza", role: "Ingegneri" }, en: { sector: "Quality & Safety", role: "Engineers" }, n: 2 },
  { it: { sector: "Qualità e Sicurezza", role: "Diplomati" }, en: { sector: "Quality & Safety", role: "Diploma holders" }, n: 1 },
];

export const TEAM_STATS = [
  { value: "40+", it: "In organico", en: "On staff" },
  { value: "7", it: "Capo cantieri", en: "Site managers" },
  { value: "Italia", it: "Copertura nazionale", en: "National coverage" },
];

export const LAVORI_CATEGORIES = [
  { id: "petrolifero", it: "Settore petrolifero", en: "Fuel sector" },
  { id: "ristorazione", it: "Ristorazione e aree ristoro", en: "Catering & rest areas" },
];

export const LAVORI = {
  petrolifero: {
    it: { title: "Settore petrolifero", intro: "I.E.P.E.M. opera da oltre 40 anni nella distribuzione carburanti, realizzando impianti chiavi in mano per i principali operatori petroliferi italiani." },
    en: { title: "Fuel sector", intro: "I.E.P.E.M. has worked in fuel distribution for over 40 years, delivering turnkey stations for Italy's leading oil operators." },
    groups: [
      {
        client: "Stazioni di servizio",
        location: "Sestri Levante · Lecce Ovest · Chianti Est",
        photos: [
          { img: "/projects/totalerg-sestri-levante.webp", it: "Sestri Levante — vista frontale", en: "Sestri Levante — front view" },
          { img: "/projects/totalerg-lecce-ovest.webp", it: "Lecce Ovest — direzione Brindisi", en: "Lecce Ovest — direction Brindisi" },
          { img: "/projects/totalerg-chienti-est.webp", it: "Chianti Est", en: "Chianti Est" },
        ],
      },
    ],
  },
  ristorazione: {
    it: { title: "Ristorazione e aree ristoro", intro: "Interventi per i principali brand della ristorazione italiana su rete stradale e autostradale, dalla ristrutturazione alla costruzione chiavi in mano." },
    en: { title: "Catering & rest areas", intro: "Projects for Italy's leading catering brands on road and motorway networks, from renovation to turnkey construction." },
    groups: [
      {
        client: "Roadhouse Grill",
        location: "Lido di Camaiore (LU)",
        photos: [
          { img: "/projects/roadhouse-facciata.jpg", it: "Esterno — nuova facciata", en: "Exterior — new façade" },
          { img: "/projects/roadhouse-sala.jpg", it: "Interno — sala ristorante", en: "Interior — dining hall" },
          { img: "/projects/roadhouse-ingresso.jpg", it: "Esterno — ingresso principale", en: "Exterior — main entrance" },
          { img: "/projects/roadhouse-bar.jpg", it: "Interno — area bar", en: "Interior — bar area" },
        ],
      },
    ],
  },
  civile: {
    it: { title: "Civile e post-sisma", intro: "Una lunga esperienza nel settore civile, dalla costruzione residenziale agli interventi di ricostruzione post-sismica su tutto il territorio nazionale." },
    en: { title: "Civil & post-earthquake", intro: "Long experience in the civil sector, from residential construction to post-earthquake reconstruction across Italy." },
    groups: [
      {
        client: "Cioccolateria Vetusta Nursia",
        location: "Norcia (PG) · Sisma 2016",
        photos: [
          { img: "/projects/nursia-esterno.jpg", it: "Edificio storico — esterno", en: "Historic building — exterior" },
          { it: "Lavori di ripristino impianti", en: "Systems restoration works" },
        ],
      },
      {
        client: "Lottizzazioni residenziali ed edifici plurifamiliari",
        location: "Perugia-Pianello · Ramazzano · Farneto · Piccione",
        photos: [
          { it: "Complesso residenziale", en: "Residential complex" },
          { it: "Edificio plurifamiliare", en: "Multi-family building" },
        ],
      },
    ],
  },
  pubblico: {
    it: { title: "Opere pubbliche", intro: "Interventi per enti e amministrazioni pubbliche: ricostruzione, edilizia scolastica e opere di urbanizzazione, con le qualificazioni richieste dai registri di settore." },
    en: { title: "Public works", intro: "Projects for public bodies and authorities: reconstruction, school building and urbanisation works, with the qualifications required by sector registers." },
    groups: [
      {
        client: "Comune di Montalto delle Marche",
        location: "Sisma 2016",
        photos: [
          { img: "/projects/montalto-prima.jpg", it: "Edificio prima dei lavori", en: "Building before works" },
          { img: "/projects/montalto-ricostruzione.jpg", it: "Ricostruzione in corso", en: "Reconstruction in progress" },
        ],
      },
      {
        client: "SUA Provincia di Perugia",
        location: "Comune di Città di Castello",
        photos: [
          { it: "Intervento in corso", en: "Works in progress" },
          { it: "Opera completata", en: "Completed work" },
        ],
      },
    ],
  },
};

export const CLIENT_GROUPS = [
  {
    it: { title: "Settore petrolifero e carburanti" },
    en: { title: "Fuel & petroleum sector" },
    items: [
      "Gruppo A.P.I. S.p.A. (IP, ENI, AGIP, TotalErg)",
      "SHELL Italia S.p.A.",
      "Tamoil S.p.A.",
      "Q8 — Kuwait Petroleum Italia S.p.A.",
      "Gradi Gualtiero S.r.l.",
      "Hitrac Engineering G. S.p.A.",
    ],
  },
  {
    it: { title: "Ristorazione e aree ristoro" },
    en: { title: "Catering & rest areas" },
    items: [
      "Gruppo Cremonini — Chef Express, Roadhouse Grill",
      "Autogrill Italia S.p.A.",
      "McDonald's",
    ],
  },
  {
    it: { title: "Civile e pubblico" },
    en: { title: "Civil & public" },
    items: [
      "Privati — lottizzazioni ed edifici plurifamiliari",
      "SUA Provincia di Perugia — Città di Castello",
      "Ater Umbria",
      "Comune di Castelplanio",
      "Regione Umbria",
    ],
  },
];
